import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useGlobalState } from "../../contexts/GlobalContext";
import { Routes } from "../../utils/constants";
import { ROUTE_LABELS } from "../../utils/constants/constant";

const CompletedResetPass: React.FC = () => {
  const { setStateValue } = useGlobalState();
  const nav = useNavigate();

  return (
    <div className="reset-password-page confirm-step">
      <section>
        <div className="rp-head">
          <div className="step-info">
            <div className="page-title">
              <span>
                <img src="/images/register/Indicator5.png" alt="" />
              </span>
              <span>パスワード変更完了</span>
            </div>
          </div>
        </div>
      </section>
      <section className="register-form">
        <div>
          <div className="buttons ">
            <button className="btn-submit" onClick={() => nav(Routes.USER)}>
              <span>ログインへ進む</span>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CompletedResetPass;
